import React, { useState } from "react";
import { fetchContentExtractions } from "../../../apis/scormUpload";
import PaginationControls from "../PaginationControls";
import ScormProcess from "./ScormProcess";
import { ToastContainer } from "react-toastify";

const PAGE_SIZE = 5;

const ScormProcessesList = () => {
  const [processes, setProcesses] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  React.useEffect(() => {
    fetchContentExtractions(page)
      .then((res) => {
        setProcesses(res.data.results);
        setTotalCount(res.data.count);
        setLoading(false);
      })
      .catch(() => {
        setError("Failed to load extraction processes");
        setLoading(false);
      });
  }, [page]);

  const totalPages = Math.ceil(totalCount / PAGE_SIZE);

  return (
    <div className="container py-1 mb-5 pb-5">
      <ToastContainer />
      <div className="card border-0 pb-5">
        <div className="card-body p-3">
          <h3 className="mb-4 text-center fw-semibold text-dark">SCORM Extraction Processes</h3>
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : error ? (
            <div className="alert alert-danger text-center">{error}</div>
          ) : processes.length === 0 ? (
            <div className="text-center text-muted py-5">No extraction processes found.</div>
          ) : (
            <>
            <div className="list-group mb-4">
              {processes.map((proc) => (
                <ScormProcess key={proc.id} proc={proc} />
              ))}
            </div>
            <PaginationControls page={page} totalPages={totalPages} setPage={setPage} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ScormProcessesList; 